import { Skeleton } from '@mantine/core';
import React from 'react';
import { UpdateWorkflowWrapper } from './styles';
import { Flex } from '@mantine/core';

const FormSkeleton = () => {
  return (
    <UpdateWorkflowWrapper>
      <Flex direction="column">
        <Flex
          gap="12px"
          align="center"
          justify="flex-start"
          mt="16px"
          mb="24px"
          px={{ base: '16px', md: '0px' }}
        >
          <Skeleton width={24} height={24} />
          <Skeleton width={200} height={24} />
        </Flex>

        <Flex
          gap="16px"
          align={{ base: 'center', md: 'flex-start' }}
          direction={{ base: 'column-reverse', md: 'row' }}
        >
          <Flex direction="column" className="rightSection" gap="16px">
            <Skeleton height={400} width="100%" />
            <Skeleton height={300} width="100%" />
            <Flex gap="12px">
              <Skeleton width={97} height={32} />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </UpdateWorkflowWrapper>
  );
};

export default FormSkeleton;
